"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.h6 = exports.h5 = exports.h4 = exports.h3 = exports.h2 = exports.h1 = exports.banner = void 0;

var _styledComponents = require("styled-components");

var _Theme = _interopRequireDefault(require("../Theme"));

var _Utils = _interopRequireDefault(require("../Utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        font-size: 1.2rem;\n        line-height: 1.7rem;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        font-size: 2rem;\n        line-height: 2.5rem;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        font-size: 2rem;\n        line-height: 2.5rem;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        font-size: 2.5rem;\n        line-height: 3rem;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        font-size: 2.5rem;\n        line-height: 3rem;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        font-size: 3.2rem;\n        line-height: 4rem;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        font-size: 3rem;\n        line-height: 3.5rem;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        font-size: 4.5rem;\n        line-height: 5rem;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        font-size: 4rem;\n        line-height: 4.5rem;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var heading = (0, _styledComponents.css)(["font-family:", ";text-transform:uppercase;font-weight:700;color:", ";"], _Theme["default"].fonts.montserrat, _Theme["default"].c.black.a);
var banner = (0, _styledComponents.css)(["", " font-size:3.5rem;line-height:4rem;", " ", ""], heading, _Utils["default"].media.minWidth.tablet(_templateObject()), _Utils["default"].media.minWidth.desktop(_templateObject2()));
exports.banner = banner;
var h1 = (0, _styledComponents.css)(["font-size:2.5rem;line-height:3rem;", " ", " ", ""], heading, _Utils["default"].media.minWidth.tablet(_templateObject3()), _Utils["default"].media.minWidth.desktop(_templateObject4()));
exports.h1 = h1;
var h2 = (0, _styledComponents.css)(["", " font-size:2rem;line-height:2.5rem;", " ", ""], heading, _Utils["default"].media.minWidth.tablet(_templateObject5()), _Utils["default"].media.minWidth.desktop(_templateObject6()));
exports.h2 = h2;
var h3 = (0, _styledComponents.css)(["", " font-size:1.8rem;line-height:2.3rem;", " ", ""], heading, _Utils["default"].media.minWidth.tablet(_templateObject7()), _Utils["default"].media.minWidth.desktop(_templateObject8()));
exports.h3 = h3;
var h4 = (0, _styledComponents.css)(["", " font-size:1.6rem;line-height:2.1rem;"], heading);
exports.h4 = h4;
var h5 = (0, _styledComponents.css)(["", " font-size:1.4rem;line-height:1.9rem;"], heading);
exports.h5 = h5;
var h6 = (0, _styledComponents.css)(["", " font-size:1.3rem;line-height:1.8rem;", ""], heading, _Utils["default"].media.minWidth.tablet(_templateObject9()));
exports.h6 = h6;